import { shield, backend } from '../../../api'
import { securityUrls, learnercollabUrls as appUrls } from '../../../api/urls'
import type {
  ApiResponse,
  AuthUserResponse,
  ForgotPasswordPropType,
  LoginUserRequest,
  ResetPasswordPropType,
  ShiedSocialCredsType,
  ShieldRegisterType,
  UpdateUserPropType
} from '../../../types'

export const register = async () => await backend.post(appUrls.users.REGISTER, {}).then(
  res => res?.data
)
export const signUp = async ({
  email, password, lastName, firstName
}: ShieldRegisterType) => await shield.post(
  securityUrls.auth.SIGNUP,
  {
    email, password, firstName, lastName, phone: Math.random() * 1000
  }
).then(
  res => res?.data
)
export const signIn = async ({ email, password }: LoginUserRequest) => await backend.post<ApiResponse<AuthUserResponse>>(
  securityUrls.auth.TOKEN,
  { email, password }
);
export const googleAuth = async ({ credentials }: ShiedSocialCredsType) => await shield.post(
  securityUrls.auth.GOOGLE,
  { credentials }
).then(res => res?.data)
export const facebookAuth = async ({ credentials }: ShiedSocialCredsType) => await shield.post(
  securityUrls.auth.FACEBOOK,
  { credentials }
).then(res => res?.data)
export const phoneAuth = async ({ credentials }: ShiedSocialCredsType) => await shield.post(
  securityUrls.auth.PHONE,
  { credentials }
).then(res => res?.data)
export const forgotPassword = async ({ email }: ForgotPasswordPropType) => await shield.post(
  securityUrls.auth.FORGOT_PASSWORD,
  { email }
).then(res => res?.data)
export const resetPassword = async ({
  userId,
  passwordResetId,
  password
}: ResetPasswordPropType) => await shield.post(
  securityUrls.auth.RESET_PASSWORD,
  { userId, passwordResetId, password }
).then(res => res?.data)

export const getUserInfo = async () => await backend.get(appUrls.users.DETAILS, {})
  .then(res => res?.data)

export const updateUserInfo = async (
  data: UpdateUserPropType
) => await backend.post(appUrls.users.UPDATE, data, {
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
}).then(res => res?.data).catch(err => {
  console.log(`Erro here ${JSON.stringify(err.response)}`)
})
